import React from "react";
import { FormGroup, FormControlLabel } from "@material-ui/core";
import { useStyles } from "./DateRangeGroup.styles";
import { getDateRangeName } from "./DateRangeGroup.utils";
import { Calendar } from "./Calendar";
import { Checkbox } from "./Checkbox";
import { Counter } from "./Counter";
import type { IDateRangeGroupProps } from "./DateRangeGroup.types";
import { BulkCalendarControlDateRange } from "../BulkCalendarControl.types";

export function DateRangeGroup<T extends string | number | unknown = unknown>(props: IDateRangeGroupProps<T>) {
  const classes = useStyles();
  const { items, dateRange, countLastItem, onChangeCountLastItem, hiddenCheckbox } = props;
  const { checked, onChangeChecked } = props;
  const { from, onChangeFrom } = props;
  const { to, onChangeTo } = props;

  const disabled = items.length === 0;
  const labelGroup = getDateRangeName(dateRange || BulkCalendarControlDateRange.Annual);
  const sliderMax = items.length - 1;
  return (
    <FormGroup>
      <FormControlLabel
        disabled={disabled}
        control={hiddenCheckbox === true ? <></> : <Checkbox checked={checked} onChangeChecked={onChangeChecked} disabled={disabled} />}
        label={
          <div className={classes.labelCheck} onClick={(e) => e.preventDefault()}>
            <span className={classes.labelGroup}>{labelGroup}</span>
            <Calendar items={items} disabled={disabled} dateRange={dateRange} from={from} onChangeFrom={onChangeFrom} to={to} onChangeTo={onChangeTo} />
            <Counter value={countLastItem} disabled={disabled} max={sliderMax} onChange={onChangeCountLastItem} />
          </div>
        }
      />
    </FormGroup>
  );
};
